module.exports = __webpack_public_path__ + "img/slider5.222ad62c.jpg";